import { COMPOUNDS } from '../compounds';

export const BUCHWALD_HARTWIG_CONDITION_GROUPS = [
  // BH_1_SET
  {
    catalyst: COMPOUNDS.BRETTPHOS_G3,
    base: COMPOUNDS.DBU,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
  // BH_2_SET
  {
    catalyst: COMPOUNDS.BRETTPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
  // BH_3_SET
  {
    catalyst: COMPOUNDS.ADBRETTPHOS_G3,
    base: COMPOUNDS.DBU,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
  // BH_4_SET
  {
    catalyst: COMPOUNDS.SPHOS_G3,
    base: COMPOUNDS.POTASSIUM_PHOSPHATE,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
  // BH_5_SET
  {
    catalyst: COMPOUNDS.XPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
  // BH_6_SET
  {
    catalyst: COMPOUNDS.MORDALPHOS_G3,
    base: COMPOUNDS.CESIUM_CARBONATE,
    solvent: COMPOUNDS.DIGLYME_DMSO,
  },
];
